import { render, staticRenderFns } from "./QuickQuestion.vue?vue&type=template&id=0fe25768&"
import script from "./QuickQuestion.vue?vue&type=script&lang=js&"
export * from "./QuickQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuickQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports